(function ($) {

    $.fn.listFilter = function (options) {
        return this.each(function() {
            const $this = $(this)
            const listElement = $($this.data('target'))
            // console.log('initialize listFilter', $this)
            $this.on('keyup', function () {
                const value = $(this).val()
                // console.log('listFilter onKeyUp', $this, value, listElement, listElement.children())
                listElement.children().each(function () {
                    if ($(this).text().search(new RegExp(value, "i")) > -1) {
                        $(this).show();
                    }
                    else {
                        $(this).hide();
                    }
                })
            })

            return this
        });
    }

    $('input[data-toggle="list-filter"]').listFilter()

})(jQuery)
